module.exports = __webpack_public_path__ + "static/media/image15.40c748be.jpg";